import { render, staticRenderFns } from "./category-sort.vue?vue&type=template&id=1fd690c8&"
import script from "./category-sort.vue?vue&type=script&lang=js&"
export * from "./category-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd690c8')) {
      api.createRecord('1fd690c8', component.options)
    } else {
      api.reload('1fd690c8', component.options)
    }
    module.hot.accept("./category-sort.vue?vue&type=template&id=1fd690c8&", function () {
      api.rerender('1fd690c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/category-sort/category-sort.vue"
export default component.exports